// ArcDisk design-system primitives (Tailwind utilities + the `.ds` token
// scope in ../../styles/arcdisk.css). Copied from the prototype's
// components/ui/ds with the motion and class-variance-authority dependencies
// replaced (see Modal.tsx and ../../lib/cva.ts).
export { Badge, type BadgeProps } from './Badge';
export { Button, buttonVariants, type ButtonProps } from './Button';
export { Skeleton } from './Skeleton';
export { Modal } from './Modal';
export {
  ScoreChip,
  SCORE_MARK,
  SCORE_TINT,
  SCORE_FG,
  scoreMarkInk,
  scoreBand,
} from './ScoreChip';
